import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Onboarding } from "sdk/onboardings";

type OnboardingState = Partial<Onboarding>;

interface State {
  hasLoadedInitial: boolean;
  onboarding: OnboardingState | null;
}

const initialState: State = {
  hasLoadedInitial: false,
  onboarding: null,
};

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    setHasLoadedInitial: (state, action: PayloadAction<boolean>) => {
      state.hasLoadedInitial = action.payload;
    },
    setOnboarding: (state, action: PayloadAction<Partial<Onboarding>>) => {
      state.onboarding = {
        ...state.onboarding,
        ...action.payload,
      };
    },
  },
});

export const { setHasLoadedInitial, setOnboarding } = onboardingSlice.actions;
export const { reducer } = onboardingSlice;
